export default {
	start: {
		title: "Plateforme IA",
		tips: "Transformez le défilement en revenus ! Encaissez chaque jour d’un simple geste - Votre téléphone, votre machine à argent !"
	},
	login: {
		tips: "Vous n'avez pas de compte ?",
		Signup: "S'inscrire",
		logIn: "Se connecter",
		Remember: "Se souvenir de moi",
		form: {
			label: ["Nom d'utilisateur/Téléphone", "Mot de passe"]
		},
		forgotPassword: "Mot de passe oublié ?",
		contactSupport: "Contacter le support",
		title: "Créer un compte",
		content: ["Besoin d'un compte ?", "Créer un compte ici"]
	},
	register: {
		form: {
			label: [
				"Nom d'utilisateur",
				"Téléphone",
				"Mot de passe de transaction",
				"Mot de passe de connexion",
				"Confirmer le mot de passe",
				"Sexe",
				"Code d'invitation",
				"Email",
				"Code de vérification"
			],
			rule: {
				Username: "Le nom d'utilisateur doit contenir entre 4 et 10 caractères",
				Email: "Veuillez entrer une adresse email valide",
				Phone: "Le numéro de téléphone doit comporter au moins 4 chiffres",
				ConfirmLoginPassword: "Les mots de passe ne correspondent pas",
				TradingPassword: "Le mot de passe de transaction doit comporter au moins 6 chiffres",
				LoginPassword: "Le mot de passe de connexion doit comporter au moins 6 chiffres"
			}
		},
		sendMsg: "Code envoyé ! Veuillez vérifier vos messages.",
		agree: ["J'accepte {0}", "l’Avis de confidentialité, MSA", "et les", "Conditions d'utilisation"],
		content: [
			"Créez votre compte gratuit",
			"Vous avez déjà un compte ?",
			"Connectez-vous ici",
			"Créer un compte",
			"En continuant, vous acceptez nos"
		]
	}
};
